export default __webpack_public_path__ + "static/media/effect-key-visual.501b987a.svg";